import AppConfig from "servicestack/config.model";

export default new AppConfig();
